import { roundToNearestMinutes } from "date-fns";
import { object, date, number, string } from "yup";

export const getValidation = () => {
  const nullableNumber = () =>
    number()
      .nullable()
      .default(null)
      .transform(value => (Number.isNaN(value) ? 0 : value));

  const validationSchema = object({
    timeMonitoring: date()
      .required()
      .default(roundToNearestMinutes(new Date(), { nearestTo: 5 }))
      .nullable(),
    temperature: nullableNumber(),
    heartRate: nullableNumber(),
    respiratoryRate: nullableNumber(),
    painScore: nullableNumber(),
    fluidRate: nullableNumber(),
    meanBloodPressure: nullableNumber(),
    comment: string().default(""),
    initials: string().default("")
  });

  return {
    validationSchema,
    defaultValues: validationSchema.cast({})
  };
};
